// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../../utils/Utils.bs.js");
let React = require("react");
let IconV5 = require("../../../atoms/Icon/IconV5.bs.js");
let Form__Input = require("./Form__Input.bs.js");
let Form__Label = require("./Form__Label.bs.js");
let ContentBox__Jsx3 = require("../ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");

function FormV5$Error(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "mt-1.5 text-base leading-4 font-medium text-tan-error-500 block"
  });
}

let $$Error = {
  make: FormV5$Error
};

function FormV5$Warning(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "mt-1.5 text-base leading-4 font-medium text-yellow-500 block"
  });
}

let Warning = {
  make: FormV5$Warning
};

function FormV5$SearchField$SearchFieldGoButton(props) {
  let onPress = props.onPress;
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
    children: JsxRuntime.jsx(IconV5.make, {
      icon: "arrow-right",
      size: 9
    }),
    className: param => "absolute right-[7px] bottom-[7px] pl-[1px] h-5 w-5 rounded-full bg-tan-blue-500 flex items-center justify-center text-white",
    onClick: param => onPress()
  });
}

let SearchFieldGoButton = {
  make: FormV5$SearchField$SearchFieldGoButton
};

function FormV5$SearchField$SearchFieldClearButton(props) {
  let onPress = props.onPress;
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
    children: JsxRuntime.jsx(IconV5.make, {
      icon: "react-select-cancel",
      size: 20
    }),
    className: param => "absolute right-[7px] bottom-[7px] h-5 w-5 flex items-center justify-center text-zinc-400 hover:text-zinc-600",
    onClick: param => onPress()
  });
}

let SearchFieldClearButton = {
  make: FormV5$SearchField$SearchFieldClearButton
};

function toArray(str) {
  return str.trim().split(",").map(prim => prim.trim()).filter(str => str !== "");
}

function fromArray(arr) {
  return Utils.$$Array.joinWith(", ", arr);
}

function FormV5$SearchField(props) {
  let __onFocus = props.onFocus;
  let __onBlur = props.onBlur;
  let __onChange = props.onChange;
  let value = props.value;
  let onChange = __onChange !== undefined ? __onChange : prim => {};
  let onBlur = __onBlur !== undefined ? __onBlur : prim => {};
  let onFocus = __onFocus !== undefined ? __onFocus : prim => {};
  let match = React.useState(() => fromArray(value));
  let setTempValue = match[1];
  let tempValue = match[0];
  React.useEffect(() => {
    setTempValue(param => fromArray(value));
  }, [value]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Input.make, {
        labelText: props.labelText,
        type: "search",
        placeholderText: props.placeholderText,
        grow: true,
        onChange: e => {
          let newValue = e.target.value;
          setTempValue(param => newValue);
        },
        onKeyDown: e => {
          if (e.key === "Enter") {
            return onChange(toArray(tempValue));
          }
        },
        onBlur: e => {
          onBlur(e);
          onChange(toArray(tempValue));
        },
        onFocus: e => onFocus(e),
        value: tempValue
      }),
      tempValue.trim() !== fromArray(value) ? JsxRuntime.jsx(FormV5$SearchField$SearchFieldGoButton, {
          onPress: () => onChange(toArray(tempValue))
        }) : (
          value.length !== 0 ? JsxRuntime.jsx(FormV5$SearchField$SearchFieldClearButton, {
              onPress: () => {
                setTempValue(param => "");
                onChange([]);
              }
            }) : null
        )
    ],
    className: "relative flex-grow"
  });
}

let SearchField = {
  SearchFieldGoButton: SearchFieldGoButton,
  SearchFieldClearButton: SearchFieldClearButton,
  toArray: toArray,
  fromArray: fromArray,
  make: FormV5$SearchField
};

function FormV5$FormGroup(props) {
  let children = props.children;
  let __wide = props.wide;
  let __inline = props.inline;
  let label = props.label;
  let inline = __inline !== undefined ? __inline : true;
  let wide = __wide !== undefined ? __wide : false;
  return JsxRuntime.jsx("div", {
    children: inline ? JsxRuntime.jsxs("div", {
        children: [
          label !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Form__Label.make, {
                labelText: label
              }),
              className: "col-span-12 md:col-span-4 lg:col-span-3 xl:col-span-2"
            }) : null,
          JsxRuntime.jsx("div", {
            children: children,
            className: wide ? "col-span-12 md:col-span-8 lg:col-span-9 xl:col-span-10" : "col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-6"
          })
        ],
        className: "grid grid-cols-12"
      }) : JsxRuntime.jsxs("div", {
        children: [
          label !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Form__Label.make, {
                labelText: label
              }),
              className: "col-span-12"
            }) : null,
          JsxRuntime.jsx("div", {
            children: children,
            className: wide ? "col-span-12 md:col-span-8 lg:col-span-9 xl:col-span-10" : "col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-6"
          })
        ],
        className: "grid grid-cols-12"
      }),
    className: "mb-6 lg:mb-4"
  });
}

let FormGroup = {
  make: FormV5$FormGroup
};

function FormV5$FormSection$SectionTitle(props) {
  return JsxRuntime.jsx("h5", {
    children: props.children,
    className: "pb-2.5 border-b border-zinc-200 mb-6 font-semibold leading-5 text-zinc-700"
  });
}

let SectionTitle = {
  make: FormV5$FormSection$SectionTitle
};

function FormV5$FormSection(props) {
  let __paddingFull = props.paddingFull;
  let tipbox = props.tipbox;
  let title = props.title;
  let paddingFull = __paddingFull !== undefined ? __paddingFull : true;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(ContentBox__Jsx3.make, {
          paddingFull: paddingFull,
          children: [
            title !== undefined ? JsxRuntime.jsx(FormV5$FormSection$SectionTitle, {
                children: title
              }) : null,
            props.children,
            tipbox !== undefined ? JsxRuntime.jsx("div", {
                children: tipbox,
                className: "mt-4 lg:hidden"
              }) : null
          ]
        }),
        className: "col-span-12 lg:col-span-9"
      }),
      tipbox !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: tipbox,
              className: "absolute w-full"
            }),
            className: "relative"
          }),
          className: "hidden lg:block col-span-3"
        }) : null
    ],
    className: "grid grid-cols-12 gap-0 lg:gap-4"
  });
}

let FormSection = {
  SectionTitle: SectionTitle,
  make: FormV5$FormSection
};

let Checkbox;

let RadioButton;

let RadioButtonGroup;

let Switch;

let Label;

let HelpLabel;

let InputField;

let TextAreaField;

let RadioCardList;

let RadioList;

exports.Checkbox = Checkbox;
exports.RadioButton = RadioButton;
exports.RadioButtonGroup = RadioButtonGroup;
exports.Switch = Switch;
exports.$$Error = $$Error;
exports.Warning = Warning;
exports.Label = Label;
exports.HelpLabel = HelpLabel;
exports.InputField = InputField;
exports.TextAreaField = TextAreaField;
exports.SearchField = SearchField;
exports.FormGroup = FormGroup;
exports.FormSection = FormSection;
exports.RadioCardList = RadioCardList;
exports.RadioList = RadioList;
/* Utils Not a pure module */
